import { Module } from 'vuex';
import { RootState, ListStatus } from '@/store/types';
import { BannerStandOrdersState } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

const state: BannerStandOrdersState = {
  list: [],
  listStatus: ListStatus.Loading,
  listPagination: {
    currentPage: 1,
    lastPage: 1,
    total: 0,
  },
  current: null,
};

const bannerStandOrders: Module<BannerStandOrdersState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};

export default bannerStandOrders;
